import { useState, useEffect, useCallback } from 'react';
import { getCircuitBreaker, resetCircuitBreaker } from '../services/BeholderService';

/**
 * Estado do circuit breaker (disparado = automações pausadas até reset manual).
 * Retorna { active, resetting, reset, refresh }.
 * pollInterval: ms entre recargas automáticas (0 = sem polling).
 */
export default function useCircuitBreaker(pollInterval = 0) {
    const [active, setActive] = useState(false);
    const [resetting, setResetting] = useState(false);

    const refresh = useCallback(() => {
        getCircuitBreaker()
            .then(r => setActive(!!(r && r.active)))
            .catch(() => { /* silencioso: indicador não deve poluir a tela em falha de rede */ });
    }, []);

    const reset = useCallback(() => {
        setResetting(true);
        return resetCircuitBreaker()
            .then(() => { setActive(false); setResetting(false); })
            .catch(err => { setResetting(false); throw err; });
    }, []);

    useEffect(() => {
        refresh();
        if (!pollInterval) return;
        const id = setInterval(refresh, pollInterval);
        return () => clearInterval(id);
    }, [refresh, pollInterval]);

    return { active, resetting, reset, refresh };
}
